export enum TrainingStatus {
	Trained = 10,
	Expiring = 20,
	Expired = 30,
}